import React from 'react';
import FormItemEditorRenderForAutoLookup from './FormItemEditorRenderForAutoLookup';
import FormItemDecimalDisplay from '../display/FormItemDecimalDisplay';
require('../../styles/FormItemRender.css');
export default class FormItemDecimalRenderForAutoLookup extends FormItemEditorRenderForAutoLookup
{
	constructor(props) {
		super(props);
	}
	
	getDisplay(_value)
	{
		if(_value == null || _value == undefined)
			_value = this.props.value;
		let parms = {};
		if(this.props.displayStyle == "%")
			parms.percent = true;
		_value = FormItemDecimalDisplay.getDisplayText(_value,this.props.showZero,
									this.props.showDecimals,this.props.thousandSeperator,parms);

		return _value;
	}

	render()
	{
		let _value = this.props.rowData[this.props.dataField];
		_value = this.getDisplay(_value);
		
		return(
			<div className="gongqi_render_select" style={{padding:'3px'}} ref={ node => this.componentLabel = node }>
				{_value}
			</div>
			
		);
	}
}


// WEBPACK FOOTER //
// ./src/formItem/renders/FormItemDecimalRenderForAutoLookup.js